// Industry templates — pre-fill examples for the New Offer form
export const TEMPLATES = [
  {
    id: "agency-fb-ads",
    label: "Marketing Agency",
    sub: "Facebook / Instagram ads retainer",
    data: {
      current_offer:
        "We run Facebook & Instagram ads for e-commerce brands. $2,500/mo retainer + 10% of ad spend. We optimize creative weekly and report on ROAS.",
      target_customer:
        "DTC e-commerce founders doing $50K–$500K/month in revenue.",
      current_price: "$2,500/mo + 10% of ad spend",
      pain_points:
        "Burned by 'expert' agencies, hate long retainers, slow onboarding, vague reporting, want ROI proof before paying.",
      dream_outcome:
        "3x ROAS on $100K+/mo ad spend within 90 days — predictable profitable scale.",
      industry: "E-commerce / DTC",
    },
  },
  {
    id: "b2b-saas",
    label: "B2B SaaS",
    sub: "Self-serve product subscription",
    data: {
      current_offer:
        "Monthly SaaS subscription for AI-powered sales prospecting. $99/mo per seat, includes 500 enriched leads & email sequences.",
      target_customer:
        "B2B SaaS sales leaders managing 3–10 SDRs with quotas in the $500K+ ARR range.",
      current_price: "$99/mo per seat",
      pain_points:
        "Tool fatigue, low SDR adoption, can't prove ROI to CFO, contract lock-in, slow time-to-first-meeting.",
      dream_outcome:
        "10 booked sales meetings per SDR per week from week one.",
      industry: "B2B SaaS",
    },
  },
  {
    id: "coaching",
    label: "Coaching",
    sub: "1:1 high-ticket coaching",
    data: {
      current_offer:
        "12-week 1:1 mindset & business coaching program. Weekly 60-min calls + Voxer support + private workbook.",
      target_customer:
        "Solopreneurs and consultants earning $5K–$20K/month wanting to scale to $50K/month.",
      current_price: "$6,000 one-time",
      pain_points:
        "Burned by gurus, info overload, hate generic frameworks, fear time commitment, want guaranteed outcomes.",
      dream_outcome:
        "Hit $50K/month in 6 months with a repeatable client acquisition system.",
      industry: "Coaching / Consulting",
    },
  },
  {
    id: "web-design",
    label: "Web Design Studio",
    sub: "Conversion-focused websites",
    data: {
      current_offer:
        "Custom Webflow website design + development. 6-week timeline, $8,000 flat fee, includes copywriting & 2 rounds of revisions.",
      target_customer:
        "Series A / B SaaS startups and DTC brands launching new products.",
      current_price: "$8,000 flat fee",
      pain_points:
        "Slow agencies, missed deadlines, generic templates, no conversion focus, painful revision cycles.",
      dream_outcome:
        "A high-conversion site live in under 30 days that lifts demo-bookings by 40%.",
      industry: "Web Design",
    },
  },
  {
    id: "real-estate",
    label: "Real Estate",
    sub: "Investor / buyer agent",
    data: {
      current_offer:
        "Buyer's agent service for first-time investors. Property search, due diligence, negotiation, closing — standard 3% commission.",
      target_customer:
        "Tech professionals with $150K+ household income buying first investment property.",
      current_price: "3% commission",
      pain_points:
        "Don't trust agents, fear overpaying, analysis paralysis, no time to research, terrified of bad tenants.",
      dream_outcome:
        "Own first cash-flowing rental within 90 days without quitting their day job.",
      industry: "Real Estate",
    },
  },
  {
    id: "ecom-product",
    label: "E-commerce Product",
    sub: "Premium DTC offer",
    data: {
      current_offer:
        "Premium skincare bundle: serum + moisturizer + sunscreen. $89 one-time purchase. 30-day money-back guarantee.",
      target_customer:
        "Women 28–45 frustrated with sensitive-skin breakouts and dull complexion.",
      current_price: "$89 one-time",
      pain_points:
        "Wasted hundreds on brands that didn't work, sensitive to ingredients, doubt 'natural' claims, fear another flop.",
      dream_outcome:
        "Clear, glowing skin in under 21 days without a 10-step routine.",
      industry: "DTC Beauty",
    },
  },
];
